import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import PoiInfo from '../common/PoiInfo/script'
import RedBagAndFoodList from '../common/RedBagAndFoodList/script'
import RedBagOnly from '../common/RedBagOnly/script';

import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();

const renderTopPoi = (props) => {
    const component = TopPoi({ ...props });
    dom.$id(domId).outerHTML = component;
}

const TopPoi = (props) => {
    const {
        itemIndex = -1,
        hasTitleImg,
        isLazyLoadImg,
        needImpMonitor,
        poiInfo,
        onShopClick,
        onPoiInfoClick,
        onHasFoodClick,
        onNoFoodRedBagClick
    } = props;

    const data = {
        itemIndex,
        domId,
        isLazyLoadImg,
        needImpMonitor,
        hasTitleImg,
        hasFoodList: props.poiInfo.skuInfoList && props.poiInfo.skuInfoList.length,
        renderPoiInfo: PoiInfo({
            topPoi: poiInfo,
            isLazyLoadImg: isLazyLoadImg || false,
            onPoiInfoClick: onPoiInfoClick ? onPoiInfoClick : null
        }),
        renderRedBagAndFoodList: RedBagAndFoodList({
            topPoi: poiInfo,
            isLazyLoadImg: isLazyLoadImg || false,
            onHasFoodClick: onHasFoodClick ? onHasFoodClick : null
        }),
        renderRedBagOnly: RedBagOnly({
            topPoi: poiInfo,
            onNoFoodRedBagClick: onNoFoodRedBagClick ? onNoFoodRedBagClick : null
        }),
    };
    const events = {
        onShopClick: (e) => {
            onShopClick && onShopClick();
        }
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
}

export default TopPoi;
export { renderTopPoi };